import { Box } from "@mui/material";
import { FC } from "react";

import DatepickerFormikMUI from "web/Layout/Datepicker/datepickerFormikMUI";
import {
  BIRTH_DATE_MAX,
  BIRTH_DATE_MIN,
} from "web/Layout/SubscriptionReceivers/SubscriptionReceiverForm/ActiveForm/constants";
import __ from "web/Layout/Translations";

import { peselMask } from "web/utils/peselMask";

import type { RequirePeselField } from "web/types/Subscription";

import CheckboxMUI from "../Checkbox/checkboxMUI";
import FieldMUI from "../Field/fieldMUI";

interface IRequirePeselFormProps {
  field: RequirePeselField;
  tooltipMessage?: string;
  isMobile: boolean;
  lang?: {
    key: string;
    code: string;
  };
}

const labels = {
  pl: {
    babyOrForeigner: "Obcokrajowiec / nowonarodzone dziecko",
    pesel: "Pesel",
    birthDate: "Data urodzenia",
  },
  en: {
    babyOrForeigner: "Foreigner/newborn baby",
    pesel: "Pesel number",
    birthDate: "Date of birth",
  },
};

const RequirePeselFormMUI: FC<IRequirePeselFormProps> = ({
  field,
  tooltipMessage,
  isMobile,
  lang = { key: "pl_PL", code: "pl" },
}) => {
  const langLabels = labels[lang.code as keyof typeof labels];

  return (
    <Box sx={{ mt: 2 }}>
      <CheckboxMUI
        name={`${field.id}.babyOrForeigner`}
        dataT1={`${field.id}.babyOrForeigner`}
        tooltipMessage={tooltipMessage}
      >
        {__(langLabels.babyOrForeigner)}
      </CheckboxMUI>

      <DatepickerFormikMUI
        name={`${field.id}.birthDate`}
        label={__(langLabels.birthDate)}
        placeholder="DD/MM/YYYY"
        minDate={BIRTH_DATE_MIN}
        maxDate={BIRTH_DATE_MAX}
        isMobile={isMobile}
        sx={{ mt: 2, maxWidth: "512px" }}
      />

      <FieldMUI
        name={`${field.id}.pesel`}
        label={__(langLabels.pesel)}
        mask={peselMask}
        placeholder="- - - - - - - - - - -"
        dataT1={`${field.id}.pesel`}
        sx={{ mb: 0, maxWidth: "512px" }}
      />
    </Box>
  );
};

export default RequirePeselFormMUI;
